import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { KB_MIN_SIMILARITY_MAX, KB_MIN_SIMILARITY_MIN, KB_MIN_SIMILARITY_STEP } from "@/utils/kb-match-strictness";

interface KbMatchStrictnessProps {
  value: number;
  onChange: (value: number) => void;
}

/** How close a knowledge-base result must be to the caller's question for the agent to use it
 * (`config.kbMinSimilarity`, saved on Publish). */
export function KbMatchStrictness({ value, onChange }: KbMatchStrictnessProps) {
  return (
    <div className="space-y-2 pt-4 border-t">
      <Label>Match strictness: {value.toFixed(2)}</Label>
      <Slider
        value={[value]}
        onValueChange={([next]) => onChange(next)}
        min={KB_MIN_SIMILARITY_MIN}
        max={KB_MIN_SIMILARITY_MAX}
        step={KB_MIN_SIMILARITY_STEP}
      />
      <p className="text-xs text-muted-foreground">
        Higher: the agent uses only close matches from your knowledge bases. Lower: it uses looser matches too.
      </p>
    </div>
  );
}
